<template>
    <div class="flex flex-column">
        <div class="flex flex-column gap-6 mb-4">
            <div class="flex align-items-center">
                <Button label="Back" icon="pi pi-arrow-left" class="p-button-text back-button cursor-pointer "
                    @click="$emit('back')" />
            </div>
            <div class="flex flex-column">
                <span class="Paragraph-Medium">Subjects</span>
                <div class="flex flex-wrap align-items-start justify-content-start gap-3 py-5 ">
                    <span v-for="module in subjects" :key="module"
                        class="flex items-center justify-center px-2 py-2 rounded Caption subjects">
                        {{ cleanupLables(module) }}</span>
                </div>
            </div>
            <span class="Paragraph-Medium -mt-6">Previous Classes</span>
        </div>

        <div v-if="previousClasses.length > 0" class="grid-container">
            <div v-for="(item, index) in previousClasses" :key="index">
                <Card class="Card p-4 h-full">
                    <template #content>
                        <div class="flex flex-column gap-2 w-full">
                            <div style="display: flex; justify-content: flex-end; margin-bottom: 1rem;">
                                <Badge :severity="item.isPaid ? 'success' : 'warn'">{{ item.isPaid ? 'Paid' : 'Payment Pending' }}</Badge>
                                </div>
                            <span
                                class="Paragraph-Medium mb-2 white-space-nowrap overflow-hidden text-overflow-ellipsis"
                                :title="item.subject">
                                {{ cleanupLables(item.subject) }}
                            </span>
                            <span class="Caption">{{ cleanupLables(item.classType) }}</span>
                            <span class="Caption" v-if="item.location">At {{ cleanupLables(item.location) }}</span>
                            <span class="Caption flex gap-3">
                                <span>{{ item.classDate }}</span><span>{{ item.classTime }}</span>
                            </span>
                        </div>
                    </template>
                    <template #footer>
                        <div class="flex justify-content-center mt-3">
                            <Button label="View" class="orange-button-small view w-8rem"
                                @click="$emit('view-class-details', item.id)" />
                        </div>
                    </template>
                </Card>
            </div>
        </div>
        <div v-else class="text-center Caption text-gray-700 mt-5">
            You don't have any previous classes with this tutor.
        </div>
    </div>
</template>

<script setup>
import { defineProps, defineEmits, computed } from 'vue';
import Card from "primevue/card";
import Button from "primevue/button";
import { cleanupLables } from "@/utils/cleanups";
import { Badge } from 'primevue';

const props = defineProps({
    previousClasses: {
        type: Array,
        required: true
    }
});

const subjects = computed(() => {
    return [...new Set(props.previousClasses.map(c => c.subject))];
});

defineEmits(['back', 'view-class-details']);
</script>
<style scoped>
.Card {
    border-radius: 4px;
    box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.16);
}

.grid-container {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(16rem, 1fr));
    gap: 3rem
}

.orange-button-small {
    width: 8rem !important;
}

.Card {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.subjects {
    border: 1px solid var(--gray-700) !important;
    border-radius: 50px;
    background-color: transparent;
}
</style>